import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Sidebar from "./Sidebar";
import Header from "./Header";
import SubHeader from "./SubHeader";
import "../Style/PdfGuideLine.css";
import { BASE_URL } from "../Apis/apiConfig";
import { useNavigate } from "react-router-dom";

export default function PdfGuideLine() {
  const [notes, setNotes] = useState([""]);
  const [loading, setLoading] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const addNote = () => setNotes([...notes, ""]);
  const updateNote = (index, value) => {
    const updated = [...notes];
    updated[index] = value;
    setNotes(updated);
  };

  const deleteNote = (index) => {
    const updated = notes.filter((_, i) => i !== index);
    setNotes(updated);
  };

const handleSave = async () => {
  setLoading(true);

  try {
    const formData = new URLSearchParams();
    const societyName = localStorage.getItem("society");
    const token = localStorage.getItem("token");
    formData.append("societyName", societyName);

    notes.forEach((note) => {
      formData.append("notes", note);
    });

    await axios.post(
      `${BASE_URL}/society-setting/add-society-setting`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    toast.success(" Guidelines saved successfully");
    setNotes([""]);   
  } catch (e) {
    console.error(e);
    toast.error(" Failed to save guidelines");
  }

  setLoading(false);
};
  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="container">
            <div className="card">
            <div className="headerRow">
              <h2 className="title">Bill Guidelines</h2>

              <button
                onClick={() => navigate("/guideline-list")}
                className="viewBtn"
              >
                📄 View All Guidelines
              </button>
            </div>
              {notes.map((note, index) => (
                <div key={index} className="noteRow">
                  <div className="number">{index + 1}.</div>

                  <textarea
                    value={note}
                    onChange={(e) => updateNote(index, e.target.value)}
                    placeholder="Enter full guideline (e.g. For NEFT/RTGS: Beneficiary: DEMO SOCIETY...)"
                    className="textarea"
                  />

                  {notes.length > 1 && (
                    <button
                      onClick={() => deleteNote(index)}
                      className="delete"
                    >
                      ✕
                    </button>
                  )}
                </div>
              ))}
              <div className="actions">
                <button onClick={addNote} className="addBtn">
                  + Add Note
                </button>

                <button onClick={handleSave} className="saveBtn">
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>

              <div className="helperBox">
                <p><b>Instructions:</b></p>
                <ul>
                  <li>Enter complete guideline text</li>
                  <li>Each line will appear as numbered point in bill</li>
                  <li>You can add multiple guidelines</li>
                </ul>
              </div>
            </div>
          </div>
        </main>
      </div>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}